import { combineReducers } from 'redux';

import dashboard from './dashboard';
import details from './details';

/**
 * @typedef {{
 *  details: import('./details').StepUiDetailsReducer,
 *  dashboard: import('./dashboard').StepUiDashboardReducer
 * }} StepUiReducer
 */

export default combineReducers({
  details,
  dashboard,
});
